module.exports = __webpack_public_path__ + "d428a6fea0987c242805cf5223ef9291.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/investment-advisor-icon.png
// module id = 1969
// module chunks = 0